export const version = '4.0.0';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: true,
  APIBaseURL: process.env.REACT_APP_API_BASE_URL,
  APIWsBaseURL: process.env.REACT_APP_API_WS_BASE_URL
};

export const genericErrorMessage =
  'Something went wrong. We could not process your request.';

export const errorCodes = {
  csrfFailure: 'csrf_failure',
  authenticationRequired: 'authentication_required',
  validationError: 'validation_error'
};
export const nonFieldErrorsKey = '__all__';

export const appPaths = {
  index: '/',
  errors: {
    notFound: '/errors/404/'
  },
  auth: {
    login: '/auth/login/',
    register: '/auth/register/',
    forgotPassword: '/auth/forgot-password/',
    resetPassword: '/auth/reset-password/:userId/:resetToken/',
    verifyEmail: '/auth/verify-email/:verificationToken/'
  },
  settings: {
    billing: '/settings/billing/',
    profile: '/settings/profile/',
    updateUser: '/settings/profile/user/edit/'
  },
  vms: {
    list: '/vms/',
    create: '/vms/create/',
    detail: '/vms/:id/',
    delete: '/vms/:id/delete/'
  }
};

export const apiPaths = {
  appVms: {
    vms: {
      list: '/app-vms/vms/',
      create: '/app-vms/vms/create/',
      detail: id => `/app-vms/vms/${id}/`,
      delete: id => `/app-vms/vms/${id}/delete/`,
      setupOpenClaw: id => `/app-vms/vms/${id}/setup-openclaw/`,
      setupHermes: id => `/app-vms/vms/${id}/setup-hermes/`,
      openclawStatus: id => `/app-vms/vms/${id}/openclaw-status/`,
      openclawProxy: vmId => `/app-vms/vms/${vmId}/openclaw/`
    }
  },
  appUsers: {
    users: {
      detail: '/app-users/users/me/',
      delete: '/app-users/users/me/delete/',
      update: '/app-users/users/me/update/'
    },
    auth: {
      csrf: '/app-users/auth/csrf/',
      status: '/app-users/auth/status/',
      login: '/app-users/auth/login/',
      logout: '/app-users/auth/logout/',
      register: '/app-users/auth/register/',
      sendPasswordResetLink: '/app-users/auth/send-password-reset-link/',
      resetPassword: '/app-users/auth/reset-password/',
      sendEmailVerificationLink:
        '/app-users/auth/send-email-verification-link/',
      verifyEmail: '/app-users/auth/verify-email/'
    }
  },
  appBilling: {
    accounts: {
      detail: '/app-billing/accounts/my/'
    },
    subscription: {
      subscribe: '/app-billing/subscription/subscribe/',
      update: '/app-billing/subscription/update/',
      customerPortalUrl: '/app-billing/subscription/customer-portal-url/'
    }
  }
};

export const apiWsPaths = {
  appVms: {
    vms: {
      screen: vmId => `/app-vms/vms/screens/${vmId}/`
    }
  }
};

export default {
  version,
  navbarBreakPoint,
  topNavbarBreakpoint,
  settings,
  errorCodes,
  nonFieldErrorsKey,
  genericErrorMessage
};
